/* EcuLab FX : mots flottants en arrière-plan, effet au clic, apparition au défilement */
(function () {
  var cfg = window.EculabFX || {};
  if (cfg.network == null) cfg.network = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Arrière-plan animé : réseau de particules + mots flottants ---------- */
  function background() {
    if (reduce || (!cfg.particles && !cfg.network)) return;
    var words = (cfg.words || '').split(/\n|,/).map(function (w) { return w.trim(); }).filter(Boolean);
    var cv = document.createElement('canvas');
    cv.className = 'eculab-fx-canvas';
    cv.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(cv, document.body.firstChild);
    document.documentElement.classList.add('eculab-fx-bg');
    var ctx = cv.getContext('2d');
    var W, H, dpr, items = [], nodes = [], last = 0, running = true, mouse = { x: -9999, y: -9999 };
    var wordA = Math.min(Math.max((cfg.opacity || 16) * 2.2, 8), 70) / 100;
    var lineA = Math.min(Math.max(cfg.line_opacity || 30, 5), 80) / 100;
    var RGB = '77,141,255';
    var FONT = '"Orbitron", "Barlow Condensed", "Arial Narrow", sans-serif';

    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function wordCount() { var b = cfg.density || 14; return W < 750 ? Math.round(b * 0.55) : b; }
    function nodeCount() { var b = cfg.nodes || 70; return Math.round(W < 750 ? b * 0.45 : b * Math.min(W * H / (1440 * 900), 1.3)); }
    function link() { return W < 750 ? 105 : 150; }
    function spawnWord(initial) {
      var small = W < 750;
      return {
        t: words[Math.floor(Math.random() * words.length)],
        x: Math.random() * W, y: Math.random() * H,
        vx: (Math.random() - 0.5) * 12, vy: -5 - Math.random() * 12,
        fs: (small ? 12 : 14) + Math.random() * (small ? 8 : 16),
        w: Math.random() < 0.4 ? 800 : 600,
        dur: 7 + Math.random() * 7, age: initial ? Math.random() * 6 : 0,
        rot: (Math.random() - 0.5) * 0.14
      };
    }
    function spawnNode() {
      var a = Math.random() * Math.PI * 2, sp = 8 + Math.random() * 22;
      return { x: Math.random() * W, y: Math.random() * H, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, r: 1 + Math.random() * 1.8, ph: Math.random() * 6.28 };
    }
    /* Zones de texte : l'animation est effacée derrière chaque texte pour qu'il reste lisible */
    var zones = [], opaqueCache = new WeakMap();
    function isOpaque(el) {
      if (opaqueCache.has(el)) return opaqueCache.get(el);
      var cs = getComputedStyle(el), m = cs.backgroundColor.match(/[\d.]+/g), r = false;
      if (m && (m.length < 4 || +m[3] > 0.85)) r = true;
      if (!r && el.parentElement && el.parentElement !== document.body && el.parentElement !== document.documentElement) r = isOpaque(el.parentElement);
      opaqueCache.set(el, r); return r;
    }
    function refreshZones() {
      opaqueCache = new WeakMap();
      var out = [], sy = window.pageYOffset, sx = window.pageXOffset;
      var roots = document.querySelectorAll('main, .shopify-section-group-footer-group');
      for (var k = 0; k < roots.length; k++) {
        var tw = document.createTreeWalker(roots[k], NodeFilter.SHOW_TEXT, null), n, range = document.createRange();
        while ((n = tw.nextNode())) {
          if (!n.nodeValue || !n.nodeValue.trim()) continue;
          var el = n.parentElement; if (!el || el.closest('script,style,noscript,[hidden],.eculab-fx-canvas')) continue;
          if (isOpaque(el)) continue;
          range.selectNodeContents(n);
          var rs = range.getClientRects();
          for (var i = 0; i < rs.length; i++) { var r = rs[i]; if (r.width < 2 || r.height < 2) continue; out.push([r.left + sx, r.top + sy, r.width, r.height]); }
        }
      }
      /* fusionne les lignes proches pour obtenir des blocs */
      out.sort(function (a, b) { return a[1] - b[1] || a[0] - b[0]; });
      var merged = [];
      out.forEach(function (r) {
        for (var j = merged.length - 1; j >= 0 && j >= merged.length - 8; j--) {
          var m = merged[j];
          if (r[1] <= m[1] + m[3] + 14 && r[0] <= m[0] + m[2] + 30 && r[0] + r[2] >= m[0] - 30) {
            var x1 = Math.min(m[0], r[0]), y1 = Math.min(m[1], r[1]), x2 = Math.max(m[0] + m[2], r[0] + r[2]), y2 = Math.max(m[1] + m[3], r[1] + r[3]);
            m[0] = x1; m[1] = y1; m[2] = x2 - x1; m[3] = y2 - y1; return;
          }
        }
        merged.push(r.slice());
      });
      zones = merged;
    }
    function rr(x, y, w, h, rad) { ctx.beginPath(); if (ctx.roundRect) ctx.roundRect(x, y, w, h, rad); else ctx.rect(x, y, w, h); ctx.fill(); }
    function eraseZones() {
      if (!zones.length) return;
      var sy = window.pageYOffset, sx = window.pageXOffset;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      for (var i = 0; i < zones.length; i++) {
        var z = zones[i], x = z[0] - sx, y = z[1] - sy;
        if (y > H + 40 || y + z[3] < -40) continue;
        ctx.fillStyle = 'rgba(0,0,0,0.45)'; rr(x - 26, y - 20, z[2] + 52, z[3] + 40, 22);
        ctx.fillStyle = 'rgba(0,0,0,0.7)'; rr(x - 18, y - 13, z[2] + 36, z[3] + 26, 16);
        ctx.fillStyle = '#000'; rr(x - 10, y - 7, z[2] + 20, z[3] + 14, 10);
      }
      ctx.restore();
    }

    function fade(p) { var k = p.age / p.dur; return Math.max(0, k < 0.25 ? k / 0.25 : k > 0.75 ? (1 - k) / 0.25 : 1); }

    function drawNetwork(dt, ts) {
      var n = cfg.network ? nodeCount() : 0, L = link(), L2 = L * L, i, j, p, q;
      while (nodes.length < n) nodes.push(spawnNode());
      if (nodes.length > n) nodes.length = n;
      for (i = 0; i < nodes.length; i++) {
        p = nodes[i];
        var mdx = mouse.x - p.x, mdy = mouse.y - p.y, md = mdx * mdx + mdy * mdy;
        if (md < 40000 && md > 1) { p.vx += mdx / Math.sqrt(md) * 14 * dt; p.vy += mdy / Math.sqrt(md) * 14 * dt; }
        var spd = Math.sqrt(p.vx * p.vx + p.vy * p.vy); if (spd > 40) { p.vx *= 40 / spd; p.vy *= 40 / spd; }
        p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.x < -20) p.x = W + 20; else if (p.x > W + 20) p.x = -20;
        if (p.y < -20) p.y = H + 20; else if (p.y > H + 20) p.y = -20;
      }
      ctx.lineWidth = 1;
      for (i = 0; i < nodes.length; i++) {
        p = nodes[i];
        for (j = i + 1; j < nodes.length; j++) {
          q = nodes[j];
          var dx = p.x - q.x, dy = p.y - q.y, d2 = dx * dx + dy * dy;
          if (d2 < L2) {
            ctx.strokeStyle = 'rgba(' + RGB + ',' + ((1 - Math.sqrt(d2) / L) * lineA).toFixed(3) + ')';
            ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(q.x, q.y); ctx.stroke();
          }
        }
        var mx = p.x - mouse.x, my = p.y - mouse.y, m2 = mx * mx + my * my;
        if (m2 < 40000) {
          ctx.strokeStyle = 'rgba(140,185,255,' + ((1 - Math.sqrt(m2) / 200) * lineA * 1.6).toFixed(3) + ')';
          ctx.beginPath(); ctx.moveTo(p.x, p.y); ctx.lineTo(mouse.x, mouse.y); ctx.stroke();
        }
      }
      for (i = 0; i < nodes.length; i++) {
        p = nodes[i];
        var tw = 0.55 + 0.45 * Math.sin(ts / 700 + p.ph);
        ctx.fillStyle = 'rgba(150,190,255,' + (0.35 + 0.5 * tw * lineA * 2).toFixed(3) + ')';
        ctx.shadowColor = 'rgba(' + RGB + ',0.9)'; ctx.shadowBlur = 8;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * (0.8 + 0.4 * tw), 0, 6.283); ctx.fill();
      }
      ctx.shadowBlur = 0;
    }
    function drawWords(dt) {
      if (!cfg.particles || !words.length) return;
      var n = wordCount();
      while (items.length < n) items.push(spawnWord(last < 600));
      for (var i = items.length - 1; i >= 0; i--) {
        var p = items[i];
        p.age += dt; p.x += p.vx * dt; p.y += p.vy * dt;
        if (p.age >= p.dur) { items.splice(i, 1); continue; }
        var a = fade(p) * wordA * (p.fs / 26 + 0.4);
        ctx.save();
        ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.font = p.w + ' ' + p.fs + 'px ' + FONT;
        ctx.fillStyle = 'rgba(' + RGB + ',' + a.toFixed(3) + ')';
        ctx.shadowColor = 'rgba(' + RGB + ',' + (a * 0.8).toFixed(3) + ')'; ctx.shadowBlur = 14;
        ctx.fillText(p.t.toUpperCase(), 0, 0);
        ctx.restore();
      }
      if (items.length > n) items.length = n;
    }
    function frame(ts) {
      if (!running) return;
      var dt = Math.min((ts - last) / 1000 || 0, 0.1); last = ts;
      ctx.clearRect(0, 0, W, H);
      drawNetwork(dt, ts);
      drawWords(dt);
      eraseZones();
      requestAnimationFrame(frame);
    }
    size();
    window.addEventListener('resize', function () { size(); refreshZones(); });
    refreshZones();
    window.addEventListener('load', refreshZones);
    setInterval(function () { if (!document.hidden) refreshZones(); }, 1200);
    document.addEventListener('click', function () { setTimeout(refreshZones, 60); setTimeout(refreshZones, 450); }, true);
    document.addEventListener('toggle', function () { setTimeout(refreshZones, 30); }, true);
    window.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') { mouse.x = e.clientX; mouse.y = e.clientY; } }, { passive: true });
    document.addEventListener('pointerleave', function () { mouse.x = mouse.y = -9999; });
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) { last = performance.now(); requestAnimationFrame(frame); }
    });
    var go = function () { requestAnimationFrame(function (ts) { last = ts; frame(ts); }); };
    if (document.fonts && document.fonts.load) {
      Promise.race([document.fonts.load('800 20px "Orbitron"'), new Promise(function (r) { setTimeout(r, 1500); })]).then(go, go);
    } else go();
  }

  /* ---------- 2. Effet au clic (onde + étincelles) ---------- */
  var SEL = '.button, button, [type="submit"], .shopify-payment-button__button, .eculab-hero__cta, .eculab-guide__choice, .eculab-qf__item summary, .product-form__submit, .cart__checkout-button, .header__menu-item, .eculab-chat__fab, [data-go]';
  function sparks(e) {
      for (var i = 0; i < 8; i++) {
        var s = document.createElement('span');
        s.className = 'eculab-fx-spark';
        var ang = (Math.PI * 2 * i) / 8 + Math.random() * 0.4, dist = 22 + Math.random() * 18;
        s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
        s.style.setProperty('--dx', Math.cos(ang) * dist + 'px');
        s.style.setProperty('--dy', Math.sin(ang) * dist + 'px');
        document.body.appendChild(s);
        setTimeout(function (n) { return function () { n.remove(); }; }(s), 650);
      }
  }
  var RIPPLE = '.button, .eculab-hero__cta, .eculab-guide__choice, .product-form__submit, .cart__checkout-button, .shopify-payment-button__button';
  function clicks() {
    if (!cfg.clicks) return;
    document.addEventListener('pointerdown', function (e) {
      var el = e.target.closest && e.target.closest(SEL);
      if (!el || el.disabled) return;
      el.classList.remove('eculab-fx-press'); void el.offsetWidth; el.classList.add('eculab-fx-press');
      if (reduce) return;
      sparks(e);
      if (!el.matches(RIPPLE)) return;
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      if (cs.position === 'static') el.style.position = 'relative';
      if (cs.overflow !== 'hidden' && el.tagName !== 'SUMMARY') el.classList.add('eculab-fx-clip');
      var d = Math.max(r.width, r.height) * 2.2;
      var rip = document.createElement('span');
      rip.className = 'eculab-fx-ripple';
      rip.style.width = rip.style.height = d + 'px';
      rip.style.left = (e.clientX - r.left - d / 2) + 'px';
      rip.style.top = (e.clientY - r.top - d / 2) + 'px';
      el.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 700);
    }, { passive: true });
  }

  /* ---------- 3. Apparition des sections au défilement ---------- */
  function reveal() {
    if (!cfg.reveal || reduce || !('IntersectionObserver' in window)) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('main .shopify-section'));
    secs = secs.slice(1); /* la première section (héros) reste affichée tout de suite */
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top < vh * 0.92) return;
      s.classList.add('eculab-fx-reveal');
      io.observe(s);
    });
  }

  function init() { background(); clicks(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
